import * as React from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const Test: React.FC = () => {

  const history = useHistory();

  return (
    <div>
      <Container>
        <Row className="align-items-center">
          <Button onClick={() => history.push('/login-admin-sso?accessToken=provaprovaprova')}>Test</Button>
        </Row>
      </Container>
    </div>
  );
}

export default Test;



